import { apiFetch } from "../apiClient";
import type { JoinMemberRequest, JoinMemberResponse, Tenant } from "../../types";

export function getPublicTenant(slug: string): Promise<{ tenant: Tenant }> {
  return apiFetch(`/public/tenants/${encodeURIComponent(slug)}`);
}

export function joinTenant(slug: string, payload: JoinMemberRequest): Promise<JoinMemberResponse> {
  return apiFetch(`/public/tenants/${encodeURIComponent(slug)}/members`, { method: "POST", body: payload });
}
